import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M3.8 3.68L5.48 2h5.04l1.68 1.68h1.12c.928 0 1.68.752 1.68 1.68v6.162c0 .928-.752 1.68-1.68 1.68H2.68c-.928 0-1.68-.752-1.68-1.68V5.36c0-.928.752-1.68 1.68-1.68H3.8zm.828 2H3v5.522h10V5.68h-1.628L9.692 4H6.308l-1.68 1.68z"
        />
        <path
          className="icon-color"
          d="M8 6c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M6 6.4L8.4 4h7.2L18 6.4h1.6c1.325 0 2.4 1.075 2.4 2.4v8.803c0 1.326-1.075 2.4-2.4 2.4H4.4c-1.325 0-2.4-1.074-2.4-2.4V8.8c0-1.325 1.075-2.4 2.4-2.4H6zM9.228 6l-2.4 2.4H4.4c-.22 0-.4.18-.4.4v8.803c0 .221.18.4.4.4h15.2c.22 0 .4-.179.4-.4V8.8c0-.22-.18-.4-.4-.4h-2.428l-2.4-2.4H9.228z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M7.5 12.5c0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5S14.485 8 12 8s-4.5 2.015-4.5 4.5zM12 10c1.38 0 2.5 1.12 2.5 2.5S13.38 15 12 15s-2.5-1.12-2.5-2.5S10.62 10 12 10z"
        />
      </g>
    </svg>
  ),
};
